import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';
import DefaultInput, {
  PriceInput as DefaultPriceInput,
} from 'components/Form/Input';
import DefaultActionButton from 'components/Buttons/ActionButton';
import { FiAlignJustify } from 'react-icons/fi';
import {
  Container as DefaultInputContainer,
  Label as DefaultLabel,
} from 'components/Form/FormSelect/styles';
import StatusSelect from 'components/Form/MenuManagmentStatusSelect';

// TODO: TFR-44 move to icon group
export const DraggableIcon = styled(FiAlignJustify)`
  display: none;
  position: absolute;
  left: -2.125rem;
  width: 1.25rem;
  height: 1.25rem;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
`;

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  padding: 2rem;
  border-radius: 1.5rem;
  margin-top: 2rem;
  position: relative;

  :hover {
    ${DraggableIcon} {
      display: initial;
    }
  }
`;

// TODO: TFR-44 move to container group
export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  grid-gap: 1.5rem;
  margin-top: 2rem;
`;

// TODO: TFR-45:Input make unique name or do not export
export const Input = styled(DefaultInput)`
  input {
    font-weight: 500;
    font-size: 1.1875rem;
  }
`;

// TODO: TFR-44 move to form group
export const PriceInput = styled(DefaultPriceInput)`
  input {
    font-weight: 500;
    font-size: 1.1875rem;
  }
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const InputContainer = styled(DefaultInputContainer)``;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Label = styled(DefaultLabel)``;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Select = styled(StatusSelect)``;

export const ActionButton = styled(DefaultActionButton)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  margin-top: 2rem;
`;
